import React from 'react';
import { motion } from 'framer-motion';
import { FiActivity, FiTrendingUp, FiBookOpen, FiChevronRight, FiCpu, } from 'react-icons/fi';

const FeatureGrid = () => {
    const features = [
        {
            icon: <FiActivity />,
            title: 'Neural Architecture',
            desc: 'Proprietary logical frameworks designed to bypass brute-force memorization and activate intuitive understanding.',
            accent: 'Σ'
        },
        {
            icon: <FiTrendingUp />,
            title: 'Predictive Analytics',
            desc: 'Data-driven model papers utilizing historical exam patterns with an 85%+ success correlation rate.',
            accent: 'dy/dx'
        },
        {
            icon: <FiBookOpen />,
            title: 'Elite Mentorship',
            desc: 'Direct, 24/7 technical advisory line for complex doubt resolution and high-performance strategy.',
            accent: '∞'
        },
        {
            icon: <FiCpu />,
            title: 'Digital Precision',
            desc: 'Proprietary simulation tools and interactive whiteboards that translate complex geometry into crystal-clear digital reality.',
            accent: 'λ'
        }
    ];

    return (
        <section className="py-24 px-6 max-w-7xl mx-auto bg-[#0a0a0a]">
            <div className="text-center mb-20">
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="flex items-center justify-center gap-4 mb-4"
                >
                    <div className="h-[2px] w-8 bg-blue-500"></div>
                    <span className="text-blue-500 font-bold uppercase tracking-widest text-xs">Our Services</span>
                    <div className="h-[2px] w-8 bg-blue-500"></div>
                </motion.div>
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="text-3xl md:text-5xl font-black tracking-tight text-white"
                >
                    LEARNING <span className="text-blue-500">MODALITIES</span>
                </motion.h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {features.map((item, idx) => (
                    <motion.div
                        key={idx}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.1 }}
                        viewport={{ once: true }}
                        className="bg-white/[0.03] backdrop-blur-xl rounded-[2.5rem] p-12 flex flex-col items-center text-center border border-white/5 hover:border-blue-500/30 transition-all duration-500 group"
                    >
                        {/* Icon Container */}
                        <div className={`w-20 h-20 rounded-3xl mb-8 flex items-center justify-center text-3xl transition-all duration-500 group-hover:scale-110 shadow-lg ${idx % 2 === 0
                            ? 'bg-blue-600 text-white shadow-blue-500/20'
                            : 'bg-white/10 text-white shadow-white/5'
                            }`}>
                            {item.icon}
                        </div>

                        <h3 className="text-xl font-black text-white mb-6 tracking-tight group-hover:text-blue-400 transition-colors">
                            {idx === 0 ? 'Physical Classes' :
                                idx === 1 ? 'Online Classes' :
                                    idx === 2 ? 'Class Recording' : 'Study Packs'}
                        </h3>

                        <p className="text-white/40 text-sm font-medium leading-relaxed">
                            {idx === 0 ? 'Direct instruction with hands-on learning and real-time interaction for maximum engagement.' :
                                idx === 1 ? 'Interactive virtual learning with live discussions and instant feedback from anywhere.' :
                                    idx === 2 ? 'Flexible learning with recorded sessions you can pause, rewind, and replay anytime.' :
                                        'Comprehensive resources with pre-recorded lectures, tutorials, and study materials.'}
                        </p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default FeatureGrid;
